import { defineColumn, type StrictColumnDef } from '../../../../components/tanstack-table/column';
import { casesOf } from '../../../../data/order-item';
import { preciseCurrencyFormatter } from '../../../../helpers/format-currency';
import type { ProductOrderItem } from '../data/product-order-item';

export const extendedBuyupCostColumn: StrictColumnDef<ProductOrderItem> =
  defineColumn<ProductOrderItem>({
    id: 'Extended Cost',
    minWidth: 80,
    accessorFn: (orderItem) =>
      preciseCurrencyFormatter(
        casesOf(orderItem) * orderItem.product.case_qty * orderItem.product.last_cost
      ),
    toCSV: (orderItem) => ({
      'Extended Cost': (
        casesOf(orderItem) *
        orderItem.product.case_qty *
        orderItem.product.last_cost
      ).toFixed(2),
    }),
  });
